import React from 'react'

function ProductListingUOMToggle({ options, label, value, onChange }) {
  const singleUOM = options.filter(option => option.value === 'Each')[0]
  const bulkUOM = options.filter(option => option.value !== 'Each')[0]
  return value === 'Each' ? (
    <div onClick={() => onChange(bulkUOM.value)}>
      <p className="listing__products-box-uom-select">Change to {bulkUOM.text} > </p>
    </div>
  ) : (
    <div className="listing__products-box-uom-container">
      <div className="listing__products-box-uom-tag">{bulkUOM.text}</div>{' '}
      <div onClick={() => onChange(singleUOM.value)}>
        <p className="listing__products-box-uom-select">Change to 1 {singleUOM.text} ></p>
      </div>
    </div>
  )
}
{
  /* <div>Case of 10</div> */
}

export default ProductListingUOMToggle
